import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Select = forwardRef(
  (
    {
      options,
      value,
      onChange,
      className = '',
      size = 'small',
      error = false,
      disabled = false,
      icon = null,
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      small: 'py-2 pr-10 pl-3 text-sm',
      medium: 'py-3 pr-10 pl-4 text-base',
      large: 'py-4 pr-12 pl-5 text-lg',
    }

    return (
      <div className="relative w-full">
        <select
          ref={ref}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={clsx(
            'block w-full appearance-none rounded-lg border border-gray-400 bg-transparent font-inherit text-gray-700 transition duration-200 ease-in-out focus:border-secondary focus:outline-none focus:ring-2 focus:ring-gray-200',
            error && 'border-red-500 focus:ring-red-200',
            disabled && 'cursor-not-allowed border-gray-300 bg-gray-200 text-secondary opacity-65',
            sizeClasses[size],
            className
          )}
          {...props}
        >
          {options.map(option => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>

        {icon && (
          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">{icon}</div>
        )}
      </div>
    )
  }
)

Select.displayName = 'Select'

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
}

export default Select
